// extracted by mini-css-extract-plugin
export default {"authInput":"styles_auth-input__O3tC6","inputLabel":"styles_input-label__Rnn7v","input":"styles_input__xiq59"};